'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onMessageReceived = undefined;

var _PubNubMessageSerializer = require('conversations-schema/serializers/PubNubMessageSerializer');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _cmfComparators = require('conversations-schema/common-message-format/operators/cmfComparators');

var _isCloseThreadMessage = require('conversations-schema/pubnub-message/operators/isCloseThreadMessage');

var _isTypingMessage = require('conversations-schema/pubnub-message/operators/isTypingMessage');

var _isContactAssociationMessage = require('conversations-schema/pubnub-message/operators/isContactAssociationMessage');

var _isOpenThreadMessage = require('conversations-schema/pubnub-message/operators/isOpenThreadMessage');

var _getUtk = require('conversations-schema/contact-association-metadata/operators/getUtk');

var _isCrmObjectLifecycleUpdate = require('conversations-schema/crm-object-lifecycle-update/operators/isCrmObjectLifecycleUpdate');

var _handleStoreMessagesCookie = require('../../post-message/actions/handleStoreMessagesCookie');

var _assignmentV2MessageReceived = require('../../actions/assignmentV2MessageReceived');

var _defaultMessageReceived = require('../../actions/defaultMessageReceived');

var _typingMessageReceived = require('../../typing-indicators/actions/typingMessageReceived');

var _chatMessageReceived = require('./chatMessageReceived');

var _cmfReceived = require('./cmfReceived');

var _closeThreadMessageReceived = require('./closeThreadMessageReceived');

var _openThreadMessageReceived = require('./openThreadMessageReceived');

var _getThreadByThreadId = require('../../threads/selectors/getThreadByThreadId');

var onMessageReceived = exports.onMessageReceived = function onMessageReceived(_ref) {
  var threadId = _ref.threadId,
      pubSubMessage = _ref.message,
      channel = _ref.channel;
  return function (dispatch, getState) {
    var messageJson = pubSubMessage.data;

    var thread = (0, _getThreadByThreadId.getThreadByThreadId)(getState(), { threadId: threadId });

    var message = (0, _PubNubMessageSerializer.deserialize)({
      json: messageJson
    });

    switch (true) {
      case (0, _messageTypeComparators.isInitialMessage)(message):
      case (0, _messageTypeComparators.isAutomatedChatMessage)(message):
      case (0, _isCrmObjectLifecycleUpdate.isCrmObjectLifecycleUpdate)(message):
        {
          // NOOP
          break;
        }

      case (0, _cmfComparators.isCommonMessageFormat)(message):
        {
          dispatch((0, _cmfReceived.cmfReceived)(message, channel, threadId));
          break;
        }

      case (0, _messageTypeComparators.isAssignmentMessageV2)(message):
        {
          dispatch((0, _assignmentV2MessageReceived.assignmentV2MessageReceived)(message, channel, threadId));
          break;
        }

      case (0, _isTypingMessage.isTypingMessage)(message):
        {
          dispatch((0, _typingMessageReceived.typingMessageReceived)(message, threadId));
          break;
        }

      case (0, _isContactAssociationMessage.isContactAssociationMessage)(message):
        {
          dispatch((0, _handleStoreMessagesCookie.handleStoreMessagesCookie)((0, _getUtk.getUtk)(message)));
          break;
        }

      case (0, _messageTypeComparators.isChatMessage)(message):
        {
          dispatch((0, _chatMessageReceived.chatMessageReceived)(message, channel, threadId));
          break;
        }

      case (0, _isCloseThreadMessage.isCloseThreadMessage)(message):
        {
          dispatch((0, _closeThreadMessageReceived.closeThreadMessageReceived)({ message: message, thread: thread, channel: channel }));
          break;
        }

      case (0, _isOpenThreadMessage.isOpenThreadMessage)(message):
        {
          dispatch((0, _openThreadMessageReceived.openThreadMessageReceived)({ message: message, channel: channel, threadId: threadId }));
          break;
        }

      default:
        {
          dispatch((0, _defaultMessageReceived.defaultMessageReceived)(message, channel, threadId));
        }
    }
  };
};